export default {
  ALARM: "alarm",
  THRESHOLD: "threshold",
  FORWARD: "forward",
  SIM_CREDIT_LOW: "sim_credit_low"
};
